import { UserActions, UserActionTypes, UserState } from '../../types/user.store.type';
import { Language, Currency, LanguageCodes, InitialLanguage } from '../../types/preference.type';
import { CookieKeys } from '../../types/keys.type';
import languages from '../../assets/languages.json';
import { ValidationUtils, SharedUtils } from '../../utils';
import currencies from '../../assets/currencies.json';

const storedLanguageCode = SharedUtils.getCookie(CookieKeys.PREFERRED_LANGUAGE);
const storedCurrency = SharedUtils.getCookie(CookieKeys.PREFERRED_CURRENCY) as Currency;

const language = languages.find((lang) => lang.code === storedLanguageCode);
const currency = currencies.find((curr) => curr === storedCurrency);

let initialLanguage: Language;
let initialCurrency: Currency;

if (language) {
    initialLanguage = {
        id: language.id,
        name: language.name,
        code: language.code as LanguageCodes,
    };
} else {
    initialLanguage = InitialLanguage;
    SharedUtils.setCookie(CookieKeys.PREFERRED_LANGUAGE, InitialLanguage.code, { domain: `${ValidationUtils.getCookieDomain()}` });
}

if (currency) {
    initialCurrency = currency as Currency;
} else {
    initialCurrency = Currency.USD;
    SharedUtils.setCookie(CookieKeys.PREFERRED_CURRENCY, initialCurrency, { domain: `${ValidationUtils.getCookieDomain()}` });
}

const initialState: UserState = {
    user: null,
    isSessionExpired: false,
    isAccessTokenExpired: false,
    language: initialLanguage,
    currency: initialCurrency,
    hidePage: true,
};

export function userReducer(state = initialState, action: UserActionTypes): UserState {
    switch (action.type) {
        case UserActions.LOGIN: {
            return { ...state, user: action.payload };
        }

        case UserActions.LOGOUT: {
            return { ...state, user: null };
        }

        case UserActions.SESSION_EXPIRED: {
            return { ...state, isSessionExpired: action.payload };
        }

        case UserActions.ACCESS_TOKEN_EXPIRED: {
            return { ...state, isAccessTokenExpired: action.payload };
        }

        case UserActions.SET_CURRENCY: {
            SharedUtils.setCookie(CookieKeys.PREFERRED_CURRENCY, action.payload, { domain: `${ValidationUtils.getCookieDomain()}` });
            return { ...state, currency: action.payload };
        }

        case UserActions.SET_LANGUAGE: {
            const newLanguage = action.payload;
            return { ...state, language: newLanguage };
        }

        case UserActions.SET_HIDE_PAGE: {
            return { ...state, hidePage: action.payload };
        }

        default: {
            return state;
        }
    }
}
